import React from 'react';
import { ReactComponent as Logo } from '../ressources/ads_logo.svg';

export default function Home({ navigate }) {
  return (
    <>
      <header className="hero" id="accueil">
        <div className="hero-overlay">
          <Logo className="hero-logo" />
          <h1 className="hero-title">Depuis plus de 40 ans,<br />nous construisons des puits<br />en Afrique de l'Ouest</h1>
          <a href="#don" className="hero-btn">Faire un don</a>
        </div>
      </header>

      <section className="about" id="about">
        <div className="section-inner">
          <h2 className="section-title">Qui sommes-nous ?</h2>
          <div className="about-content">
            <div className="about-text">
              <p>
                <strong>Action Directe Sahel</strong> est une association qui œuvre depuis plus de 40 ans
                pour apporter une eau propre et vitale aux communautés d'Afrique de l'Ouest.
              </p>
              <p>
                Nous construisons et réhabilitons des puits et des forages dans les zones les plus reculées
                de la brousse et jusqu’au Sahel, là où l'accès à l'eau potable reste un défi quotidien
                pour des milliers de familles.
              </p>
              <p>
                Chaque puits ou forage construit, c'est une communauté entière qui retrouve la dignité,
                la santé et l'espoir d'un avenir meilleur.
              </p>
              <p className="about-link-row">
                <button type="button" className="link-button" onClick={() => navigate('historique')}>
                  Découvrir l’histoire de l’association →
                </button>
              </p>
            </div>
            <div className="about-image">
              <img src={process.env.PUBLIC_URL + '/dona.webp'} alt="Une femme boit de l'eau d'un puits" />
            </div>
          </div>
        </div>
      </section>

      <section className="impact">
        <div className="section-inner">
          <h2 className="section-title section-title-light">Notre impact</h2>
          <div className="impact-grid">
            <div className="impact-card">
              <span className="impact-number">40+</span>
              <span className="impact-label">années d'engagement</span>
            </div>
            <div className="impact-card">
              <span className="impact-number">800+</span>
              <span className="impact-label">points d'eau</span>
            </div>
            <div className="impact-card">
              <span className="impact-number">500 000+</span>
              <span className="impact-label">personnes desservies</span>
            </div>
            <div className="impact-card">
              <span className="impact-number">8</span>
              <span className="impact-label">pays d'intervention</span>
            </div>
          </div>
        </div>
      </section>

      <section className="realisations" id="realisations">
        <div className="section-inner">
          <h2 className="section-title">Nos réalisations</h2>
          <p className="section-subtitle">
            Depuis notre création, nous avons mené des centaines de projets à travers le Sahel.
          </p>
          <div className="realisations-grid">
            <div className="realisation-card">
              <div className="realisation-year">2025</div>
              <h3>Campagne 2025</h3>
              <p>
                Plusieurs puits et remises en état d’anciens forages dans le pays Tamberma
                (patrimoine mondial de l’UNESCO) au Togo et au Bénin. Ce pays est un site
                où nous travaillons depuis plus de 20 ans.
              </p>
            </div>
            <div className="realisation-card">
              <div className="realisation-year">2026</div>
              <h3>Campagne 2026</h3>
              <p>
                Essentiellement projets de réhabilitation de forages dans le pays Tamberma.
              </p>
            </div>
            <div className="realisation-card">
              <div className="realisation-year">Antérieurs</div>
              <h3>40 ans d'histoire</h3>
              <p>
                Des centaines de puits construits à travers le Mali, le Burkina Faso, le Niger,
                le Nigeria, le Bénin, le Togo, le Ghana et le Cameroun.
              </p>
              <p className="realisation-link-row">
                <button type="button" className="link-button" onClick={() => navigate('projets')}>
                  Voir les projets antérieurs →
                </button>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="don" id="don">
        <div className="section-inner">
          <h2 className="section-title">Soutenez notre action</h2>
          <div className="don-layout">
            <div className="don-text-side">
              <p className="don-text">
                Chaque don compte. Grâce à votre générosité, nous pouvons continuer à construire
                des puits et offrir un accès durable à l'eau potable.
              </p>
              <p className="don-text">
                Un puits, c'est la vie pour tout un village.
              </p>
              <p className="don-note">
                Paiement 100% sécurisé via HelloAsso.<br />
                Votre don est déductible des impôts à hauteur de 66%.
              </p>
            </div>
            <div className="don-widget-side">
              <iframe
                id="haWidget"
                allowTransparency="true"
                scrolling="auto"
                src="https://www.helloasso.com/associations/action-directe-sahel/collectes/forages-au-togo-pour-automne-2026/widget"
                title="Formulaire de don HelloAsso"
                onLoad={() => window.addEventListener('message', function(e) { const dataHeight = e.data.height; const haWidgetElement = document.getElementById('haWidget'); if (dataHeight > parseFloat(haWidgetElement.height || 0)) { haWidgetElement.height = dataHeight + 'px'; } })}>
              </iframe>
            </div>
          </div>
        </div>
      </section>

      <section className="contact" id="contact">
        <div className="section-inner">
          <h2 className="section-title section-title-light">Nous contacter</h2>
          <div className="contact-grid">
            <div className="contact-item">
              <h3>Adresse</h3>
              <p>Action Directe Sahel<br />France</p>
            </div>
            <div className="contact-item">
              <h3>Email</h3>
              <p>actiondirectesahel@bbox.fr</p>
            </div>
            <div className="contact-item">
              <h3>Suivez-nous</h3>
              <p>Retrouvez-nous sur les réseaux sociaux</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
